import React from 'react'
import FormColumn from "components/formColumn"

import { emailIsValid } from 'utils'

export default ({
    section, 
    handleChange,
    values,
    isLastSlide,
    isFirstSlide,
    handleNext,
    handleBack,
    showRequiredAsterisk
}) => {
    const servicesKey = `What service/s are you interested in?`

    const {
        title,
        rowsHeading,
        rows
    } = section

    const visibleRows = []
    
    rows.forEach(row => {
        const {
            onlyShowIf,
            columns
        } = row

        let showRow = true
        let hasIdenticalKeyAlready = false

        visibleRows.forEach(_row => {
            _row.columns.forEach(_column => {
                if(_column.label === columns[0].label){
                    hasIdenticalKeyAlready = true
                }
            })
        })

        if(onlyShowIf){
            showRow = false

            const selectedServices = values[servicesKey]

            if(selectedServices){
                let comparisonKey = null

                switch(onlyShowIf){
                    case 'sales':
                        comparisonKey = 'Sales'
                        break
                    case 'merchandising':
                        comparisonKey = 'Merchandising'
                        break
                    case 'fieldManagement':
                        comparisonKey = 'Field Management Software'
                        break
                    case 'salesNegotiation':
                        comparisonKey = 'Sales & Negotiation Skills Training'
                        break
                    case 'retailInsights':
                        comparisonKey = 'Retail Insights'
                        break
                    case 'spacePlanning':
                        comparisonKey = 'Space Planning'
                        break
                    case 'demandPlanning':
                        comparisonKey = 'Demand Planning'
                        break
                }

                if(comparisonKey && selectedServices.indexOf(comparisonKey) !== -1){
                    showRow = true
                }

                const firstColumnType = columns[0].type

                if(firstColumnType === 'checkboxes' && selectedServices.length > 1){
                    showRow = false
                }
            }
        }

        if(showRow && !hasIdenticalKeyAlready){
            visibleRows.push(row)
        }
    })

    const _isValid = () => {
        let hasEmptyColumn = false

        visibleRows.forEach(row => {
            row.columns.forEach(column => {
                const value = values[column.label]

                if(showRequiredAsterisk && !column.required){
                    return
                }

                if(!value || value === ''){
                    hasEmptyColumn = true
                }else if(column.type === 'email'){
                    if(!emailIsValid(value)){
                        hasEmptyColumn = true
                    }
                }
            })
        })

        return !hasEmptyColumn
    }

    const isValid = _isValid()

    return (
        <>
            <div>
                <div className="tab-header">
                    <h2>
                        { title }
                    </h2>
                    <p>
                        { rowsHeading }
                    </p>
                </div>
                <ul>
                    { visibleRows.map((row, index) => {
                        const { columns } = row

                        return (
                            <li className="row" key={index}>
                                <ul className={`columns columns-${columns.length}`}>
                                    { columns.map((column, columnIndex) => {
                                        return (
                                            <li key={columnIndex}>
                                                <FormColumn 
                                                    column={column} 
                                                    index={columnIndex} 
                                                    handleChange={handleChange}
                                                    values={values}
                                                    showRequiredAsterisk={showRequiredAsterisk}
                                                />
                                            </li>
                                        )
                                    })}
                                </ul>   
                            </li>
                        )
                    })}
                </ul>
            </div>
            { !isFirstSlide ?
                <button 
                    className={'button outline arrow back'}
                    onClick={handleBack}
                > 
                    Go back
                </button>
            : null }
            <button 
                disabled={!isValid}
                className={`button arrow ${ !isLastSlide ? 'outline' : '' }`} 
                onClick={handleNext}
            >
                { isLastSlide ? 'Submit' : 'Next' }
            </button>
        </>
    )
}